var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 480 480",
    style: {
      transform: "rotate(180deg)"
    },
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240 440C350.457 440 440 350.457 440 240C440 129.543 350.457 40 240 40C129.543 40 40 129.543 40 240C40 350.457 129.543 440 240 440Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240 275C248.2 275 255 268.2 255 260V160C255 151.8 248.2 145 240 145C231.8 145 225 151.8 225 160V260C225 268.2 231.8 275 240 275Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M258.4 312.4C257.4 310 256 307.8 254.2 305.8C252.2 304 250 302.6 247.6 301.6C242.8 299.6 237.2 299.6 232.4 301.6C230 302.6 227.8 304 225.8 305.8C224 307.8 222.6 310 221.6 312.4C220.6 314.8 220 317.4 220 320C220 322.6 220.6 325.2 221.6 327.6C222.6 330.2 224 332.2 225.8 334.2C227.8 336 230 337.4 232.4 338.4C234.8 339.4 237.4 340 240 340C242.6 340 245.2 339.4 247.6 338.4C250 337.4 252.2 336 254.2 334.2C256 332.2 257.4 330.2 258.4 327.6C259.4 325.2 260 322.6 260 320C260 317.4 259.4 314.8 258.4 312.4Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.ae9b0959f2446832515a4593167050dd.svg";
export { ForwardRef as ReactComponent };